import React, { useContext } from 'react'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch, useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { updateProfile } from '../../../redux/slices/authSlice'
import { editProfileSchema } from '../../../util/validationSchema'
import InputMask from 'react-input-mask'
import { capitalizeFirstLetter, formatPhoneNumbertoString, maskPhoneNumber, objectsAreEqual } from '../../../helper/function'

const EditProfile = () => {
  const { user } = useSelector(({ auth }) => auth)

  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()

  const initValue = { first_name: user?.first_name, last_name: user?.last_name, email: user?.email, contact_no: maskPhoneNumber(user?.contact_no) }

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors }
  } = useForm({
    mode: 'all',
    resolver: yupResolver(editProfileSchema),
    defaultValues: initValue
  })
  const currentValue = watch()

  const hasChanged = objectsAreEqual(currentValue, initValue) || Object.keys(errors)?.length !== 0

  const onSubmit = (data) => {
    if (!user?.is_email_verified) {
      errorToast('Email not verified. Please verify email to continue')
      return
    }
    const payload = {
      first_name: data?.first_name,
      last_name: data?.last_name,
      contact_no: formatPhoneNumbertoString(data?.contact_no)
    }
    if (data) {
      changeLoader(true)
      dispatch(updateProfile(payload)).then(({ payload }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Profile updated successfully')
          changeLoader(false)
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-lg-6 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">First Name</label> <span className="text-danger">*</span>
            <Controller
              name="first_name"
              control={control}
              render={({ field: { value, onChange } }) => (
                <input
                  className={`form-control  ${errors?.first_name ? 'error-input' : ''}`}
                  type="text"
                  value={value || ''}
                  onChange={(val) => {
                    const input = val.target.value
                    const capitalized = capitalizeFirstLetter(input)
                    onChange(capitalized)
                  }}
                  autoComplete="false"
                  placeholder="Enter First Name"
                  // ref={emailRem}
                />
              )}
            />
            <small>{errors?.first_name?.message}</small>
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">Last Name</label> <span className="text-danger">*</span>
            <Controller
              name="last_name"
              control={control}
              render={({ field: { value, onChange } }) => (
                <input
                  className={`form-control  ${errors?.last_name ? 'error-input' : ''}`}
                  type="text"
                  value={value || ''}
                  onChange={(val) => {
                    const input = val.target.value
                    const capitalized = capitalizeFirstLetter(input)
                    onChange(capitalized)
                  }}
                  autoComplete="false"
                  placeholder="Enter Last Name"
                  // ref={emailRem}
                />
              )}
            />
            <small>{errors?.last_name?.message}</small>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">Email</label> <span className="text-danger">*</span>
            <Controller
              name="email"
              control={control}
              render={({ field: { value, onChange } }) => (
                <input
                  className={`form-control  ${errors?.email ? 'error-input' : ''}`}
                  type="text"
                  value={value || ''}
                  onChange={onChange}
                  autoComplete="false"
                  placeholder="Enter Email Address"
                  disabled
                />
              )}
            />
            <small>{errors?.email?.message}</small>
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="form-group input_text">
            <label>
              Phone Number <span className="text-danger">*</span>
            </label>
            <Controller
              name="contact_no"
              control={control}
              render={({ field: { value, onChange } }) => (
                <InputMask
                  mask="(999) 999-9999" // Mask format
                  value={value}
                  onChange={onChange}
                  className={`form-control ${errors?.contact_no ? 'error-input' : ''}`}
                  placeholder="Enter Phone Number"
                  autoComplete="off"
                >
                  {(inputProps) => <input {...inputProps} />}
                </InputMask>
              )}
              defaultValue=""
            />
            <small>{errors?.contact_no?.message}</small>
          </div>
        </div>
      </div>
      <div className="text-align-center">
        <button className="btn btn-lg btn-block btn-primary profile_save_btn mb-3" type="submit" disabled={user?.is_freezed_client || hasChanged}>
          Save
        </button>
      </div>
    </form>
  )
}

export default EditProfile
